import { useUserAppInfo } from "@/hooks/useUserAppInfo";

interface IProps {
  userAppId: string;
}

const AutoCarbonScore = ({ userAppId }: IProps) => {
  const { proposedCarbonScore } = useUserAppInfo(userAppId);

  if (!proposedCarbonScore) {
    return null;
  }

  return (
    <section className="rounded-lg border border-[#f2c434] bg-[#feefa2] p-4">
      <div className="flex items-start gap-3 text-[#111827]">
        <span aria-hidden="true" className="mt-0.5 inline-flex size-4 items-center justify-center opacity-90">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="8" cy="8" r="6.6667" stroke="currentColor" strokeWidth="1.5" />
            <line x1="8" y1="7" x2="8" y2="11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
            <circle cx="8" cy="4.5" r="1" fill="currentColor" />
          </svg>
        </span>
        <div className="flex min-w-0 flex-1 flex-col gap-1">
          <span className="text-sm font-semibold leading-4">Auto carbon score generated: {proposedCarbonScore}</span>
          <span className="text-sm font-normal leading-5">
            Please review the data and score before final approval. You can override this score if necessary.
          </span>
        </div>
      </div>
    </section>
  );
};

export { AutoCarbonScore };
